import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Home dashboard tabs — My Events / My Vendors / My Performers. */
export const HOME_TABS = {
  events: 'events',
  vendors: 'vendors',
  performers: 'performers',
};

/**
 * Active home tab outside the `/` route so returning from vendor/performer
 * view (or other pages) — and full page refresh — restores the last selected tab.
 */
export const useHomeDashboardStore = create(
  persist(
    (set) => ({
      activeTab: HOME_TABS.events,
      setActiveTab: (activeTab) => set({ activeTab }),
    }),
    {
      name: 'festy-home-dashboard',
      partialize: (state) => ({ activeTab: state.activeTab }),
    },
  ),
);
